import * as React from "react"
import { SVGProps } from "react"
const AppleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path d="M19.4691 20.2487C18.5483 21.6126 17.5721 22.9435 16.0855 22.9655C14.599 22.9985 14.122 22.0966 12.4358 22.0966C10.7385 22.0966 10.2171 22.9435 8.80814 22.9985C7.35488 23.0535 6.25662 21.5466 5.32476 20.2157C3.42776 17.4989 1.9745 12.4942 3.92697 9.12846C4.89211 7.45657 6.6227 6.40064 8.49752 6.36764C9.91753 6.34564 11.2709 7.32458 12.1473 7.32458C13.0126 7.32458 14.6545 6.14766 16.374 6.32365C17.0951 6.35664 19.1141 6.60963 20.412 8.5015C20.3122 8.5675 18.0047 9.90941 18.0269 12.6922C18.0602 16.014 20.9667 17.1249 21 17.1359C20.9667 17.2129 20.5341 18.7198 19.4691 20.2487ZM13.1347 2.64989C13.9445 1.73695 15.2868 1.044 16.3962 1C16.5404 2.28691 16.019 3.58483 15.2424 4.50877C14.477 5.4437 13.2123 6.16966 11.9698 6.07066C11.8034 4.80575 12.4247 3.48583 13.1347 2.64989Z" fill="white"/>
  </svg>
)
export default AppleIcon